import fetch from '@/utils/fetch';
import storage from '@/utils/storage';

const model = {
  state: {
    advanceShopList: [],
    advanceShopParams: {
      page_no: 1,
      page_size: 100,
    },
    advanceShopTotal: 0,
    tableForecastLoading: false,
    shopTableLoading: false,
    advanceForecastList: [],
    advanceForecastTime: '',
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { advanceForecast, basic }, getState }) => ({
    // 获取预估垫资金额
    async getAdvanceForecastList(is_export) {
      advanceForecast.setState({ tableForecastLoading: true });
      const data = await fetch('/saasmerchant/web/settlement/fc/getAdvanceFundList', {
        type: 'POST',
        params: { is_export: is_export || 0 },
      });
      if (data) {
        if (is_export) {
          basic.setLogListDot(true);
        } else {
          advanceForecast.setState({ advanceForecastList: data.data_list });
        }
        advanceForecast.setState({ tableForecastLoading: false });
      }
    },

    setAdvanceForecastTime(params) {
      const tempParams = params.replace(/-/g, '');
      storage.set('advanceForecastTime', tempParams);
      advanceForecast.setState({ advanceForecastTime: tempParams });
      advanceForecast.setState({ advanceShopParams: { page_no: 1, page_size: 100 } });
    },

    // 获取预估垫资金额详情
    async getAdvanceShopForecastList(is_export) {
      advanceForecast.setState({ shopTableLoading: true });
      const advanceForecastTimeStorage = storage.get('advanceForecastTime');

      const { advanceShopParams, advanceForecastTime } = getState().advanceForecast;
      const params = {
        ...advanceShopParams,
        advance_time: advanceForecastTime || advanceForecastTimeStorage,
        is_export: is_export || 0,
      };
      const data = await fetch('/saasmerchant/web/settlement/fc/getAdvanceFundDetail', {
        type: 'POST',
        params,
      });
      if (data) {
        if (is_export) {
          basic.setLogListDot(true);
        } else {
          advanceForecast.setState({
            advanceShopList: data.data_list,
            advanceShopTotal: data.data_num,
          });
        }
        advanceForecast.setState({ shopTableLoading: false });
      }
    },
    handlePage(page_no, page_size) {
      advanceForecast.setState({ advanceShopParams: { page_no, page_size } });
    },
  }),
};

export default model;
